import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

const OGServiceService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/og-service`,
});

const OGServiceServices = {
  getDetail: (token: string, id: string) =>
    OGServiceService.get(`/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  getAll: (
    token: string,
    pagination: IPaginationRequest
  ) =>
    OGServiceService.get(
      `/list?perPage=${pagination.per_page}&page=${pagination.page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  create: (
    token: string,
    data: {
      name: string;
      duration: number;
      sequence: number;
    }
  ) =>
    OGServiceService.post(``, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  edit: (
    token: string,
    id: string | number,
    data: {
      name: string;
      duration: number;
      sequence: number;
    }
  ) =>
    OGServiceService.put(`/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  delete: (token: string, id: string | number) =>
    OGServiceService.delete(`/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
};

export default OGServiceServices;
